import React , { useEffect, useState } from 'react'
import Header from '../components/Header'
import Leftmenu from '../components/Leftmenu'
import Rightmenu from '../components/Rightmenu'
import FriendCardMain from '../components/FriendCardMain'
import { useOutletContext } from 'react-router-dom'
function Connection() {
    const { user, token } = useOutletContext();
    const [friends, setFriends] = useState([]);
    const getfriends = () => {
        fetch('api/get-friend-list', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        }).then((response) => response.json())
            .then((data) => {
               
                setFriends(data.data);
            }).catch((error) => {
               
            });
    }
    useEffect(() => {
        getfriends();
    },[]);
  return (
    <div>
        <Header />
        <Leftmenu />
        <Rightmenu />
               <div className="main-content right-chat-active">
            
 <div className="middle-sidebar-bottom my-4">
  <div className="middle-sidebar-left pe-0">
    <div className="row">
      <div className="col-xl-12">
        <div className="card shadow-xss w-100 d-block d-flex border-0 p-4 mb-3">
          <div className="card-body d-flex align-items-center p-0">
            <h2 className="fw-700 mb-0 mt-0 font-md text-grey-900">Connection</h2>
      

          </div>
        </div>
        <div className="row ps-2 pe-2">
            {friends.map((friend) => (
                <FriendCardMain key={friend.id} data={friend} type={"friend"} />
            ))}          
        </div>
      </div>               
    </div>
  </div>
</div>

    </div>
    </div>
  )
}

export default Connection